var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.132,
    height: 44.132,
    viewBox: "0 0 44.132 44.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2675",
    "data-name": "Rectangle 2675",
    width: 44.132,
    height: 44.132,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M43.554,22.066A21.488,21.488,0,1,1,22.066.578,21.488,21.488,0,0,1,43.554,22.066Z",
    fill: "none",
    stroke: "#344154",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M30.678,24.641a8.919,8.919,0,0,1-2.629,4.319l4.9,4.9a15.829,15.829,0,1,0-21.773,0l4.9-4.9a8.9,8.9,0,1,1,14.468-9.286",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y2: 2.753,
    transform: "translate(22.066 6.551)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 1.376,
    y2: 2.384,
    transform: "translate(14.25 8.646)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 2.384,
    y2: 1.376,
    transform: "translate(8.528 14.368)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 2.753,
    transform: "translate(6.433 22.184)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y1: 1.376,
    x2: 2.384,
    transform: "translate(8.528 28.624)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x1: 2.384,
    y1: 1.376,
    transform: "translate(33.22 28.624)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 2.753,
    transform: "translate(34.946 22.184)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 2.384,
    y2: 1.376,
    transform: "translate(33.22 14.368)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 1.376,
    y2: 2.384,
    transform: "translate(28.506 8.646)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M23.818,22.066a1.752,1.752,0,1,1-1.752-1.752A1.752,1.752,0,0,1,23.818,22.066Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 8.737,
    transform: "translate(23.818 22.066)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReli);
export default __webpack_public_path__ + "static/media/reli.75249ba2b1b4ea08101d144520509054.svg";
export { ForwardRef as ReactComponent };